import type { ResumeTemplateDefinition, ResumeTemplateId } from "./types";
import { templateOne } from "./template-1";
import { templateTwo } from "./template-2";
import { templateThree } from "./template-3";

export const resumeTemplates = [
  templateOne,
  templateTwo,
  templateThree,
] as const;

export const resumeTemplateMap = Object.fromEntries(
  resumeTemplates.map((template) => [template.id, template]),
) as Record<ResumeTemplateId, ResumeTemplateDefinition>;

export const defaultResumeTemplateId: ResumeTemplateId =
  resumeTemplates[0].id;

export const isResumeTemplateId = (
  value: string,
): value is ResumeTemplateId => {
  return value in resumeTemplateMap;
};

export type { ResumeTemplateDefinition, ResumeTemplateId };
